import { AssessmentScore } from "src/app/core/models/assessment-score.model";
import { Assessment } from "src/app/core/models/assessment.model";

export enum SubscriptionType {
  SCREENER = 0,
  DIAGNOSTIC = 1,
  INTERVENTION = 2,
  DIAGNOSTIC_MID = 3,
  DIAGNOSTIC_POST = 4,
}

export interface StudentDisplay {
  userID: number;
  firstName: string;
  lastName: string;
  grade: number ;
  teacherID: number ;
  percentComplete: number;
  enrolledSubscription: number ;
  currentAssessment: number ;
  subscriptionExpired: boolean ;
  canBeAssignedToTeam: boolean ;
  assessments?: Assessment[] ;
  assessmentScores?: AssessmentScore[] ;
  firstAssessmentScore?: AssessmentScore ;
  scoreRange: string;
  screenerClass: string;
  skipped: boolean;
}
